"use client";
import React, { Fragment, useState } from "react";
import { useTranslation } from "@/src/i18n/client";
import { FmButton, FmDrawer, FmIcon, FmImage } from "@/ui-component";
import { ILcon, IPurchaseProps } from "..";
import stl from "./productAdvantage.module.scss";
import WarrantyTime from "./WarrantyTime";
import WarrantyTimeTips from "./WarrantyTimeTips";
import { usePageLayoutContext } from "@/src/provider";
import classnames from "classnames";
interface IProps extends IPurchaseProps {}
const ProductAdvantageClient: React.FC<React.PropsWithChildren<IProps>> = (
    props,
) => {
    const [visible, setVisible] = useState(false);
    const toggerVisible = () => {
        setVisible((prev) => !prev);
    };

    const config = usePageLayoutContext((state) => state.config);

    const H5List = config?.purchase
        ? config?.purchase.lcon
        : props.H5Purchase?.lcon || [];

    const H5View = config?.purchase
        ? config?.purchase.viewmore
        : props.H5Purchase?.viewmore || [];

    const { t } = useTranslation("common");
    return (
        <>
            {H5List ? (
                H5List.map((item: ILcon, index: number) => {
                    return (
                        <div
                            className={classnames(
                                "default_layout",
                                stl["flex-start"],
                            )}
                            key={index}
                        >
                            {item.img && (
                                <FmImage
                                    image={item.img}
                                    className={stl["lcon-img"]}
                                />
                            )}
                            <span className={stl["advantage-title"]}>
                                {item.title}
                            </span>
                        </div>
                    );
                })
            ) : (
                <>
                    <div
                        className={classnames(
                            "default_layout",
                            stl["flex-start"],
                        )}
                    >
                        <FmImage
                            className={stl["lcon-img"]}
                            image="https://df5apg8r0m634.cloudfront.net/images/291089826b7ff807a0cea99734441cd6.png"
                        />
                        <span className={stl["advantage-title"]}>
                            {t("productDetail:FreeCoatingIncluded")}
                        </span>
                    </div>
                    <div
                        className={classnames(
                            "default_layout",
                            stl["exchange-icon-container"],
                        )}
                    >
                        <FmIcon
                            icon={"icon--exchange"}
                            className={stl["icon-exchange"]}
                        />
                        <div className={stl["advantage-title"]}>
                            {t("common:advantage.title1")}
                        </div>
                    </div>
                    <div
                        className={classnames(
                            "default_layout",
                            stl["exchange-icon-container"],
                        )}
                    >
                        <FmIcon
                            icon={"icon-warranty"}
                            className={stl["icon-exchange"]}
                        />
                        <div
                            className={stl["advantage-title"]}
                            style={{ marginRight: "0.6rem" }}
                        >
                            <WarrantyTime />
                        </div>
                    </div>
                </>
            )}
            <FmButton
                className={stl["hidden-util-lconlast"]}
                onClick={toggerVisible}
                variant="text"
                width="fit-content"
            >
                <span className={stl["view-more-btn"]}>
                    {t("common:helpPage.ViewMore")}
                </span>
            </FmButton>
            <FmDrawer
                open={visible}
                closeable={true}
                onClose={toggerVisible}
                anchor="bottom"
                closeablePosition="right"
                fullHeight
                headerChildren
                childrenClassName={stl["modal-container"]}
                headerClassName={stl["modal-header-container"]}
            >
                {H5View.length > 0 ? (
                    <>
                        {H5View.map((item: any, index: number) => (
                            <Fragment key={index}>
                                <p className={stl["advantage-modal-title"]}>
                                    {item.title}
                                </p>
                                <p className={stl["advantage-modal-text"]}>
                                    {item.text}
                                </p>
                            </Fragment>
                        ))}
                    </>
                ) : (
                    <>
                        <p className={stl["advantage-modal-title"]}>
                            {t("common:advantage.title1")}
                        </p>
                        <p className={stl["advantage-modal-text"]}>
                            {t("common:DAY_EXCHANEG_TIPS")}
                        </p>
                        <p className={stl["advantage-modal-title"]}>
                            <WarrantyTime />
                        </p>
                        <p className={stl["advantage-modal-text"]}>
                            <WarrantyTimeTips />
                        </p>
                    </>
                )}
            </FmDrawer>
        </>
    );
};

export default ProductAdvantageClient;
